import en from './en';
import fr from './fr';

const Attachment = {
  en,
  fr,
};

export default Attachment;
